import { uniqueId } from 'lodash';

import { generateOrganizationId } from 'dashboard/lib/stubs/organization';
import { generateTeamId } from 'dashboard/lib/stubs/team';
import { User, UserRelationships, UserResponseAttributes, UserStatus } from 'dashboard/models/user';
import { ApiModel } from 'lib/interfaces/api';

export const generateUserSessionId = () => uniqueId('user_');

export function createMockUser(
  attributes?: Partial<UserResponseAttributes>,
  id?: string,
  relationships?: Partial<UserRelationships>,
): User {
  if (
    attributes != null &&
    attributes['role-permissions'] == null &&
    attributes.permissions != null
  ) {
    attributes['role-permissions'] = attributes.permissions.map((permission) => {
      return { name: permission, 'environment-id': null, 'object-id': null };
    });
  }

  return {
    attributes: {
      'name-first': 'Charbs',
      'name-last': 'Yea',
      'email-address': 'admin@acme.com',
      status: UserStatus.Active,
      'enabled-mfa-methods': [],
      'available-mfa-methods': [],
      'homepage-priority': ['inquiries', 'cases', 'verifications', 'reports'],
      'default-landing-page': '/inquiries',
      'enabled-nav-items': [],
      ...attributes,
    },
    relationships: {
      organization: { data: { type: ApiModel.Organization, id: generateOrganizationId() } },
      roles: { data: [] },
      teams: { data: [{ type: ApiModel.Team, id: generateTeamId() }] },
      ...relationships,
    },
    id: id || generateUserSessionId(),
    type: ApiModel.User,
  };
}

// User serializer sends less attributes when not fully authenticated
export function createMock2faUser(
  attributes?: Partial<UserResponseAttributes>,
  id?: string,
  relationships?: Partial<UserRelationships>,
): User {
  return {
    attributes: {
      'name-first': 'Charbs',
      'name-last': 'Yea',
      'email-address': 'admin@acme.com',
      status: UserStatus.Active,
      'enabled-mfa-methods': [],
      'available-mfa-methods': [],
      ...attributes,
      permissions: undefined,
      'mfa-email-confirmation-token-expires-at': undefined,
      'mfa-phone-confirmation-code-expires-at': undefined,
      'enabled-nav-items': undefined,
      'homepage-priority': undefined,
      'default-landing-page': undefined,
    },
    relationships: {
      organization: { data: { type: ApiModel.Organization, id: generateOrganizationId() } },
      roles: { data: [] },
      teams: { data: [{ type: ApiModel.Team, id: generateTeamId() }] },
      ...relationships,
    },
    id: id || generateUserSessionId(),
    type: ApiModel.User,
  };
}
